module.exports = __webpack_public_path__ + "img/Graph1.4fd102e8.png";